<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="primary"
          icon="mdi-database-cog-outline"
          inline
          class="px-5 py-3"
          :title="`Entidades BDGD Obrigatórias :: ${company.name}`"
        >
          <!-- Info Alert -->
          <v-alert dense outlined type="info" color="primary" class="mb-5 mt-4">
            Aqui você pode informar ao sistema quais são as entidades da BDGD que a
            <strong>{{ company.name }}</strong>
            precisa enviar para a ANEEL.
          </v-alert>

          <base-dual-list-transfer
            v-model="selectedEntities"
            :items="bdgdEntities"
            :loading="loading"
            left-title="Obrigatórias"
            left-icon="mdi-checkbox-marked-outline"
            right-title="Não obrigatórias"
            right-icon="mdi-format-list-bulleted"
            search-label="Pesquisar entidade obrigatória"
            select-all-label="Marcar todas"
            clear-label="Limpar obrigatórias"
            :format-label="(v) => v.toUpperCase()"
          />
        </base-material-card>
      </v-col>
    </v-row>

    <!-- Save button -->
    <v-row>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn color="primary" min-width="120" :disabled="btnSaveDisabled" :loading="loading" @click="save()">Salvar</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CompanyService from '@/services/CompanyService';
  import EntidadesBdgdService from '@/services/EntidadesBdgdService';
  import routes from '@/store/modules/routes';

  export default {
    name: 'EmpresaEntidadesObrigatorias',

    data: () => ({
      company: { name: '' },
      bdgdEntities: [],
      selectedEntities: [],
      loading: false
    }),

    computed: {
      btnSaveDisabled() {
        return !this.selectedEntities.length;
      }
    },

    mounted() {
      this.getCompany(this.$route.params.id);
      this.getAllBdgdEntities();
    },

    methods: {
      getCompany(id) {
        CompanyService.getCompanyById(id)
          .then((response) => {
            const { name, mandatory_bdgd_entities: selectedEntities } = response;
            this.company.name = name;
            this.selectedEntities = selectedEntities || [];
          })
          .catch(() => this.$toast.error('Erro ao buscar os dados da empresa.', '', { position: 'topRight' }));
      },

      getAllBdgdEntities() {
        EntidadesBdgdService.getEntidades()
          .then((response) => (this.bdgdEntities = response.data))
          .catch(() => this.$toast.error('Erro ao buscar as entidades da BDGD.', '', { position: 'topRight' }));
      },

      save() {
        this.loading = true;

        const data = { mandatory_bdgd_entities: this.selectedEntities };

        CompanyService.updateMandatoryBdgdEntities(this.$route.params.id, data)
          .then(() => {
            this.$toast.success('Entidades configuradas com sucesso.', '', { position: 'topRight' });
            this.updateMandatoryBdgdEntitiesLoggedCompany(this.selectedEntities);
            this.$router.replace({ name: routes.state.appRoutes['EMPRESAS_LISTAR'] });
          })
          .catch(() =>
            this.$toast.error('Erro ao salvar as entidades da BDGD obrigatórias para a empresa.', '', {
              position: 'topRight'
            })
          )
          .finally(() => (this.loading = false));
      },

      updateMandatoryBdgdEntitiesLoggedCompany(selectedEntities) {
        const targetCompanyId = this.$route.params.id;
        const loggedCompanyId = this.$store.getters.getCompanyId;
        if (targetCompanyId == loggedCompanyId) {
          return this.$store.dispatch('setCompanyMandatoryBdgdEntities', selectedEntities);
        }
      }
    }
  };
</script>
